import { useEffect, useState } from 'react';
import { withCookies, type ReactCookieProps } from 'react-cookie';
import axios from 'axios';

import { getRequestConfigWithHeaders } from '../../utils/requestConfig';
import SignInPage from './SignInPage';

type SignInPageContainerProps = ReactCookieProps & {
  onUserLoggedIn: () => void,
  onFailure: (error: unknown) => void,
}

function SignInPageContainer(props: SignInPageContainerProps) {
  const { onUserLoggedIn, cookies, onFailure } = props;

  const [error, setError] = useState<unknown>(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const ssoCookie = cookies!.get('ia-sso-cookie');

    if (ssoCookie) {
      setIsLoading(true);
      const requestUrl = `/api/auth/login-check`;

      axios
        .post(requestUrl, {}, getRequestConfigWithHeaders({ 'x-auth-token': ssoCookie }))
        .then(() => onUserLoggedIn())
        .catch(() => setIsLoading(false));
    }
  }, []);

  useEffect(() => {
    if (error) {
      onFailure(error);
    }
    return () => {
      setError(null);
    };
  }, [error]);

  const onForgotPasswordClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    window.alert('Please use your Google account or contact administration!');
  };

  return (
    <SignInPage onFailure={setError}
                onUserLoggedIn={onUserLoggedIn}
                onForgotPassword={onForgotPasswordClick}
                isLoading={isLoading}
                onLoadingChange={setIsLoading}
    />
  );
}

export default withCookies(SignInPageContainer);
